export const baseURL = `https://youth-festival-api.khelouk.in/`;